export const nextStatusMapping = {
    "AWAITING_PICKUP" : "PICKED_UP_FROM_CUSTOMER",
    "PICKUP_SKIPPED" : "PICKED_UP_FROM_CUSTOMER",
    "PICKED_UP_FROM_CUSTOMER" : "DROPPED_OFF_AT_LAUNDROMAT",
    "DROPPED_OFF_AT_LAUNDROMAT": "PICKED_UP_FROM_LAUNDROMAT",
    "PICKED_UP_FROM_LAUNDROMAT": "DELIVERED_TO_CUSTOMER",
    "DELIVERED_TO_CUSTOMER" : "PICKED_UP_FROM_CUSTOMER"
}

export const statusDisplay = {
    "AWAITING_PICKUP" : "Pickup Pending",
    "PICKUP_SKIPPED" : "Pickup Missed",
    "PICKED_UP_FROM_CUSTOMER" : "Hamper Collected",
    "DROPPED_OFF_AT_LAUNDROMAT": "At Laundromat",
    "PICKED_UP_FROM_LAUNDROMAT": "Picked Clean",
    "DELIVERED_TO_CUSTOMER" : "Delivered"
}

